import { cn } from "@/utils/cn";
import { Loader2Icon } from "lucide-react";
import i18n from "i18next";
function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <Loader2Icon
      role="status"
      aria-label={i18n.t("common.loading")}
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  );
}
export { Spinner };
